import BDSGeneralInformation from "./BDSGeneralInformation";
import TinymceEditor from "components/common/TinymceEditor";
import React, { useEffect } from "react";
import { CRM_PIF_BDS3_PURLIN_GIRT_SPACING } from "app_config";
import PropTypes from 'prop-types';
import { INPUT_CLS, TEXTAREA_CLS, CHECK_CLS } from "../../pifStyles";

const CHECK_LABEL_CLS = "tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-select-none";

const BDS3 = ({data}) => {
  const {area} = data;
  const {control, register, Controller, setValue} = data.useHookForm;

  const {bds3} = area;

  useEffect(() => {
    setValue(`bds3_purlin_girt_spacing_${area.id}`, CRM_PIF_BDS3_PURLIN_GIRT_SPACING)
  }, [area.id, setValue])

  useEffect(() => {
    if (bds3) {
      Object.entries(bds3).forEach(([key, value]) => {
        setValue(`bds3_${key}_${area.id}`, value)
      })
    }
  }, [bds3, setValue, area.id])

  return (
    <div className="tw-text-sm tw-border tw-border-solid tw-border-slate-200 tw-p-3 tw-bg-white tw-rounded">
      <BDSGeneralInformation data={data} />
      <h6 className="tw-text-center tw-my-2">This area only : Page 3 of 3</h6>

      <div className="tw-grid tw-grid-cols-12 tw-gap-x-3 tw-mt-5 tw-mb-3 tw-items-center">
        <div className="tw-col-span-5 tw-font-semibold">1. Please design the most economical purlin, girt spacing.</div>
        <div className="tw-col-span-7">
          <input
            placeholder="Specify design the most economical purlin, girt spacing"
            className={INPUT_CLS}
            {...register(`bds3_purlin_girt_spacing_${area.id}`)}
          />
        </div>
      </div>

      <div className="tw-mb-3">
        <div className="tw-grid tw-grid-cols-12 tw-gap-x-3">
          <div className="tw-col-span-5 tw-font-semibold">2. Deflection criterion:</div>
          <div className="tw-col-span-7">
            <div className="tw-flex tw-justify-between">
              <Controller
                control={control}
                name={`bds3_follow_building_code_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>Follow building code</span>
                  </label>
                )}
              />

              <Controller
                control={control}
                name={`bds3_follow_peb_standard_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>Follow peb standard</span>
                  </label>
                )}
              />

              <Controller
                control={control}
                name={`bds3_follow_requested_of_client_${area.id}`}
                render={({ field }) => (
                  <label className={CHECK_LABEL_CLS}>
                    <input
                      type="checkbox"
                      className={CHECK_CLS}
                      checked={!!field.value}
                      onChange={(value) => field.onChange(value)}
                    />
                    <span>Follow requested of client</span>
                  </label>
                )}
              />
            </div>
          </div>
        </div>
        <div className="tw-grid tw-grid-cols-12 tw-gap-x-3">
          <div className="tw-col-span-5">Requested of Client:</div>
          <div className="tw-col-span-7">
            <textarea
              rows={5}
              placeholder="Requested of Client"
              className={TEXTAREA_CLS}
              {...register(`bds3_follow_requested_of_client_specify_${area.id}`)}
            />
          </div>
        </div>
      </div>

      <div className="tw-grid tw-grid-cols-12 tw-gap-x-3 tw-mb-3">
        <div className="tw-col-span-4 tw-font-semibold">3. Environment conditions:</div>
        <div className="tw-col-span-8">
          <div className="tw-flex tw-justify-between">
            <Controller
              control={control}
              name={`bds3_fertilizer_${area.id}`}
              render={({ field }) => (
                <label className={CHECK_LABEL_CLS}>
                  <input
                    type="checkbox"
                    className={CHECK_CLS}
                    checked={!!field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <span>Fertilizer</span>
                </label>
              )}
            />

            <Controller
              control={control}
              name={`bds3_chemical_substance_${area.id}`}
              render={({ field }) => (
                <label className={CHECK_LABEL_CLS}>
                  <input
                    type="checkbox"
                    className={CHECK_CLS}
                    checked={!!field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <span>Chemical substance</span>
                </label>
              )}
            />

            <Controller
              control={control}
              name={`bds3_animal_feed_${area.id}`}
              render={({ field }) => (
                <label className={CHECK_LABEL_CLS}>
                  <input
                    type="checkbox"
                    className={CHECK_CLS}
                    checked={!!field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <span>Animal feed</span>
                </label>
              )}
            />
            <Controller
              control={control}
              name={`bds3_animal_shed_${area.id}`}
              render={({ field }) => (
                <label className={CHECK_LABEL_CLS}>
                  <input
                    type="checkbox"
                    className={CHECK_CLS}
                    checked={!!field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <span>Animal shed</span>
                </label>
              )}
            />

            <Controller
              control={control}
              name={`bds3_from_the_sea_100m_${area.id}`}
              render={({ field }) => (
                <label className={CHECK_LABEL_CLS}>
                  <input
                    type="checkbox"
                    className={CHECK_CLS}
                    checked={!!field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <span>From the sea 100m</span>
                </label>
              )}
            />
          </div>
        </div>
      </div>

      <div className="tw-grid tw-grid-cols-12 tw-gap-x-3 tw-mb-3">
        <div className="tw-col-span-5 tw-font-semibold">4. How many cranes can operate at the same time in the same bay?</div>
        <div className="tw-col-span-7">
          <div className="tw-flex tw-justify-between">
            <Controller
              control={control}
              name={`bds3_crane_operate_2_${area.id}`}
              render={({ field }) => (
                <label className={CHECK_LABEL_CLS}>
                  <input
                    type="checkbox"
                    className={CHECK_CLS}
                    checked={!!field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <span>2</span>
                </label>
              )}
            />

            <Controller
              control={control}
              name={`bds3_crane_operate_3_${area.id}`}
              render={({ field }) => (
                <label className={CHECK_LABEL_CLS}>
                  <input
                    type="checkbox"
                    className={CHECK_CLS}
                    checked={!!field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <span>3</span>
                </label>
              )}
            />

            <Controller
              control={control}
              name={`bds3_crane_operate_4_${area.id}`}
              render={({ field }) => (
                <label className={CHECK_LABEL_CLS}>
                  <input
                    type="checkbox"
                    className={CHECK_CLS}
                    checked={!!field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <span>4</span>
                </label>
              )}
            />
            <Controller
              control={control}
              name={`bds3_crane_operate_not_apply_${area.id}`}
              render={({ field }) => (
                <label className={CHECK_LABEL_CLS}>
                  <input
                    type="checkbox"
                    className={CHECK_CLS}
                    checked={!!field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <span>Not Apply</span>
                </label>
              )}
            />
          </div>
        </div>
      </div>

      <div className="tw-grid tw-grid-cols-12 tw-gap-x-3 tw-mb-3">
        <div className="tw-col-span-5 tw-font-semibold">5. Is Internal X-Bracing allowed?</div>
        <div className="tw-col-span-7">
          <div className="tw-flex tw-justify-between">
            <Controller
              control={control}
              name={`bds3_internal_xbracing_yes_${area.id}`}
              render={({ field }) => (
                <label className={CHECK_LABEL_CLS}>
                  <input
                    type="checkbox"
                    className={CHECK_CLS}
                    checked={!!field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <span>Yes</span>
                </label>
              )}
            />

            <Controller
              control={control}
              name={`bds3_internal_xbracing_no_${area.id}`}
              render={({ field }) => (
                <label className={CHECK_LABEL_CLS}>
                  <input
                    type="checkbox"
                    className={CHECK_CLS}
                    checked={!!field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <span>No</span>
                </label>
              )}
            />

            <Controller
              control={control}
              name={`bds3_internal_xbracing_not_apply_${area.id}`}
              render={({ field }) => (
                <label className={CHECK_LABEL_CLS}>
                  <input
                    type="checkbox"
                    className={CHECK_CLS}
                    checked={!!field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <span>Not Apply</span>
                </label>
              )}
            />
          </div>
        </div>
      </div>

      <div className="tw-mb-3">
        <div className="tw-font-semibold">6. The Top Coat Paint shall be Flat or Matte Finish ( Very low on Reflectivity)</div>
        <div className="tw-mt-3">
          <Controller
            control={control}
            name={`bds3_top_coat_paint_${area.id}`}
            render={({ field }) => (
              <TinymceEditor rollback={false}
                handleChange={field.onChange}
                value={field.value}
              />
            )}
          />
        </div>
      </div>
    </div>
  )
};

BDS3.propTypes = {
  data: PropTypes.object.isRequired
}

export default BDS3;
